import { createTheme } from '@mui/material';

declare module '@mui/material/styles' {
  interface Theme {
    paperTableContainer: { maxHeight: string };
    hoveredOrSelectedCell: { backgroundColor: string };
    oddNumberedRow: { backgroundColor: string };
    spacingValues: {
      atomSpacing: {
        spacing_atom_gap_com_gap_s: string;
        spacing_atom_gap_com_gap_m: string;
        spacing_atom_gap_com_gap_l: string;
        spacing_atom_gap_com_gap_xl: string;
        spacing_atom_padding_atom_padding_s: string;
        spacing_atom_padding_atom_padding_m: string;
        spacing_atom_padding_atom_padding_l: string;
      };
      buttonSpacing: {
        spacing_button_large_button_lg_gap: string;
        spacing_button_large_button_lg_padding_s: string;
        spacing_button_large_iconbutton_lg_padding: string;
        spacing_button_large_button_lg_padding_m: string;
        spacing_button_large_button_lg_padding_l: string;
        spacing_button_middle_button_md_gap: string;
        spacing_button_middle_button_md_padding_s: string;
        spacing_button_middle_iconbutton_md_padding: string;
        spacing_button_middle_button_md_padding_m: string;
        spacing_button_middle_button_md_padding_l: string;
        spacing_button_middle_button_md_padding_xl: string;
        spacing_button_small_button_sm_gap: string;
        spacing_button_small_button_sm_padding_s: string;
        spacing_button_small_iconbutton_sm_padding: string;
        spacing_button_small_button_sm_padding_m: string;
        spacing_button_small_button_sm_padding_l: string;
      };
      componentSpacing: {
        spacing_component_gap_com_gap_xs: string;
        spacing_component_gap_com_gap_s: string;
        spacing_component_gap_com_gap_m: string;
        spacing_component_gap_com_gap_l: string;
        spacing_component_padding_com_padding_xs: string;
        spacing_component_padding_com_padding_s: string;
        spacing_component_padding_com_padding_m: string;
        spacing_component_padding_com_padding_l: string;
        // NEW
        spacing_component_gap_2: string;
        spacing_component_gap_4: string;
        spacing_component_gap_8: string;
        spacing_component_gap_12: string;
        spacing_component_gap_16: string;
        spacing_component_gap_24: string;
        spacing_component_padding_4: string;
        spacing_component_padding_8: string;
        spacing_component_padding_12: string;
        spacing_component_padding_16: string;
        spacing_component_padding_24: string;
        spacing_component_padding_32: string;
      };
      inputFieldSpacing: {
        spacing_inputfield_padding_inputfield_padding_xs: string;
        spacing_inputfield_padding_inputfield_padding_s: string;
        spacing_inputfield_padding_inputfield_padding_m: string;
        spacing_inputfield_padding_inputfield_padding_l: string;
      };
      pageSpacing: {
        spacing_page_gap_page_gap_xxs: string;
        spacing_page_gap_page_gap_xs: string;
        spacing_page_gap_page_gap_s: string;
        spacing_page_gap_page_gap_m: string;
        spacing_page_gap_page_gap_l: string;
        spacing_page_gap_page_gap_xl: string;
        spacing_page_margin_page_margin_xs: string;
        spacing_page_margin_page_margin_s: string;
        spacing_page_margin_page_margin_m: string;
        spacing_page_margin_page_margin_l: string;
        spacing_page_margin_page_margin_xl: string;
        // NEW
        spacing_page_gap_4: string;
        spacing_page_gap_8: string;
        spacing_page_gap_16: string;
        spacing_page_gap_24: string;
        spacing_page_gap_32: string;
        spacing_page_gap_48: string;
        spacing_page_gap_56: string;
        spacing_page_gap_64: string;
        spacing_page_margin_4: string;
        spacing_page_margin_8: string;
        spacing_page_margin_16: string;
        spacing_page_margin_24: string;
        spacing_page_margin_32: string;
        spacing_page_margin_48: string;
        spacing_page_margin_56: string;
        spacing_page_margin_64: string;
      };
    };
    shape: {
      border_radius_tso_border_radius_2: string;
      border_radius_tso_border_radius_4: string;
    };
    customShadows: {
      elevation_1: string;
    };
  }
  interface ThemeOptions {
    paperTableContainer: { maxHeight: string };
    hoveredOrSelectedCell: { backgroundColor: string };
    oddNumberedRow: { backgroundColor: string };
    spacingValues: {
      atomSpacing: {
        spacing_atom_gap_com_gap_m: string;
        spacing_atom_padding_atom_padding_m: string;
      };
      buttonSpacing: {
        spacing_button_large_button_lg_gap: string;
        spacing_button_large_button_lg_padding_s: string;
        spacing_button_large_iconbutton_lg_padding: string;
        spacing_button_large_button_lg_padding_m: string;
        spacing_button_large_button_lg_padding_l: string;
        spacing_button_middle_button_md_gap: string;
        spacing_button_middle_button_md_padding_s: string;
        spacing_button_middle_iconbutton_md_padding: string;
        spacing_button_middle_button_md_padding_m: string;
        spacing_button_middle_button_md_padding_l: string;
        spacing_button_middle_button_md_padding_xl: string;
        spacing_button_small_button_sm_gap: string;
        spacing_button_small_button_sm_padding_s: string;
        spacing_button_small_iconbutton_sm_padding: string;
        spacing_button_small_button_sm_padding_m: string;
        spacing_button_small_button_sm_padding_l: string;
      };
      componentSpacing: {
        spacing_component_gap_com_gap_xs: string;
        spacing_component_gap_com_gap_s: string;
        spacing_component_gap_com_gap_m: string;
        spacing_component_gap_com_gap_l: string;
        spacing_component_padding_com_padding_xs: string;
        spacing_component_padding_com_padding_s: string;
        spacing_component_padding_com_padding_m: string;
        spacing_component_padding_com_padding_l: string;
        // NEW
        spacing_component_gap_2: string;
        spacing_component_gap_4: string;
        spacing_component_gap_8: string;
        spacing_component_gap_12: string;
        spacing_component_gap_16: string;
        spacing_component_gap_24: string;
        spacing_component_padding_4: string;
        spacing_component_padding_8: string;
        spacing_component_padding_12: string;
        spacing_component_padding_16: string;
        spacing_component_padding_24: string;
        spacing_component_padding_32: string;
      };
      inputFieldSpacing: {
        spacing_inputfield_padding_inputfield_padding_xs: string;
        spacing_inputfield_padding_inputfield_padding_s: string;
        spacing_inputfield_padding_inputfield_padding_m: string;
        spacing_inputfield_padding_inputfield_padding_l: string;
      };
      pageSpacing: {
        spacing_page_gap_page_gap_xxs: string;
        spacing_page_gap_page_gap_xs: string;
        spacing_page_gap_page_gap_s: string;
        spacing_page_gap_page_gap_m: string;
        spacing_page_gap_page_gap_l: string;
        spacing_page_gap_page_gap_xl: string;
        spacing_page_margin_page_margin_xs: string;
        spacing_page_margin_page_margin_s: string;
        spacing_page_margin_page_margin_m: string;
        spacing_page_margin_page_margin_l: string;
        spacing_page_margin_page_margin_xl: string;
        // NEW
        spacing_page_gap_4: string;
        spacing_page_gap_8: string;
        spacing_page_gap_16: string;
        spacing_page_gap_24: string;
        spacing_page_gap_32: string;
        spacing_page_gap_48: string;
        spacing_page_gap_56: string;
        spacing_page_gap_64: string;
        spacing_page_margin_4: string;
        spacing_page_margin_8: string;
        spacing_page_margin_16: string;
        spacing_page_margin_24: string;
        spacing_page_margin_32: string;
        spacing_page_margin_48: string;
        spacing_page_margin_56: string;
        spacing_page_margin_64: string;
      };
    };
    customShadows: {
      elevation_1: string;
      elevation_2: string;
      elevation_3: string;
    };
    shape: {
      border_radius_tso_border_radius_2: string;
      border_radius_tso_border_radius_4: string;
    };
  }

  interface TypographyVariants {
    ubuntu: string;
    openSans: string;
    fontsize_body_body_small: string;
    fontsize_body_body_medium: string;
    fontsize_body_body_large: string;
    fontsize_button_button_small: string;
    fontsize_button_button_medium: string;
    fontsize_button_button_large: string;
    fontsize_label_label_small: string;
    fontsize_label_label_medium: string;
    fontsize_label_label_large: string;
    lineHeight_s: string;
    lineHeight_m: string;
    lineHeight_l: string;
    lineHeight_xl: string;
    line_height_21: string;
    fontsize_support_support_text_large: string;
    fontsize_support_support_text_medium: string;
    fontsize_support_support_text_small: string;
    fontsize_title_list_section_small: string;
    fontsize_title_list_section_medium: string;
    fontsize_title_list_section_large: string;
    fontsize_title_section_smaller: string;
    fontsize_title_section_small: string;
    fontsize_title_section_medium: string;
    fontsize_title_titel_large: string;
  }

  interface TypographyVariantsOptions extends TypographyVariants {}
}

declare module '@mui/material/styles' {
  interface TypeBackground {
    primary: {
      color_primary_background_bg_prim: string;
      color_primary_background_bg_prim_accent: string;
      color_primary_background_bg_prim_enabled: string;
      color_primary_background_bg_prim_enabled_lt: string;
      color_primary_background_bg_prim_hover: string;
      color_primary_background_bg_prim_hover_lt: string;
      color_primary_background_bg_prim_lt: string;
      color_primary_background_bg_prim_pressed: string;
      color_primary_background_bg_prim_pressed_lt: string;
    };
    other: {
      color_other_background: string;
      color_other_background_white: string;
    };
    neutral: {
      color_neutral_background_bg_neutral_lt: string;
      color_neutral_background_bg_ntrl: string;
      color_neutral_background_bg_ntrl_accent: string;
      color_neutral_background_bg_ntrl_dark: string;
      color_neutral_background_bg_ntrl_disabled: string;
      color_neutral_background_bg_ntrl_enabled: string;
      color_neutral_background_bg_ntrl_enabled_lt: string;
      color_neutral_background_bg_ntrl_hover: string;
      color_neutral_background_bg_ntrl_hover_lt: string;
      color_neutral_background_bg_ntrl_pressed: string;
      color_neutral_background_bg_ntrl_pressed_lt: string;
    };
    tso: {
      active: {
        color_tso_background_amprion: string;
        color_tso_background_tennet: string;
        color_tso_background_50hertz: string;
        color_tso_background_transnet: string;
      };
      hover: {
        color_tso_background_amprion: string;
        color_tso_background_tennet: string;
        color_tso_background_50hertz: string;
        color_tso_background_transnet: string;
      };
      pressed: {
        color_tso_background_amprion: string;
        color_tso_background_tennet: string;
        color_tso_background_50hertz: string;
        color_tso_background_transnet: string;
      };
    };
  }
}

declare module '@mui/material/styles' {
  interface Palette {
    customTextColor: {
      color_font_ft_helping_text: string;
      color_font_ft_nrtrl_disabled: string;
      color_font_ft_second_text: string;
      color_font_ft_text: string;
      color_font_ft_white: string;
      color_neutral_font_ft_nrtrl_enabled: string;
      color_neutral_font_ft_nrtrl_hover: string;
      color_neutral_font_ft_nrtrl_pressed: string;
      color_neutral_font_ft_ntrl_accent: string;
      color_neutral_font_ft_ntrl_lt: string;
      color_primary_font_ft_prim_accent: string;
      color_primary_font_ft_prim_enabled: string;
      color_primary_font_ft_prim_hover: string;
      color_primary_font_ft_prim_lt: string;
      color_primary_font_ft_prim_pressed: string;
    };
    customError: {
      color_signal_error_error: string;
      color_signal_error_error_2: string;
      color_signal_error_error_bg_accent: string;
      color_signal_error_error_bg_accent_2: string;
      color_signal_error_error_bg_dark: string;
      color_signal_error_error_bg_dark_2: string;
      color_signal_error_error_bg_light: string;
      color_signal_error_error_bg_light_2: string;
    };
    customInformation: {
      color_signal_information_information: string;
      color_signal_information_information_bg_accent: string;
      color_signal_information_information_bg_dark: string;
      color_signal_information_information_bg_light: string;
      color_signal_success_success: string;
      color_signal_success_success_bg_accent: string;
      color_signal_success_success_bg_dark: string;
      color_signal_success_success_bg_light: string;
      color_signal_warning_warning: string;
      color_signal_warning_warning_bg_accent: string;
      color_signal_warning_warning_bg_dark: string;
      color_signal_warning_warning_bg_light: string;
    };
    stroke: {
      color_primary_stroke_str_prim_accent: string;
      color_primary_stroke_str_prim_enabled: string;
      color_primary_stroke_str_prim_hover: string;
      color_primary_stroke_str_prim_pressed: string;

      color_neutral_stroke_str_ntrl_accent: string;
      color_neutral_stroke_str_ntrl_disabled: string;
      color_neutral_stroke_str_ntrl_enabled: string;
      color_neutral_stroke_str_ntrl_hover: string;
      color_neutral_stroke_str_ntrl_pressed: string;
    };
    chart: Record<string, string>;
    table: {
      color_other_table_header: string;
    };
    tso: {
      active: {
        color_tso_background_amprion: string;
        color_tso_background_tennet: string;
        color_tso_background_50hertz: string;
        color_tso_background_transnet: string;
      };
      hover: {
        color_tso_background_amprion: string;
        color_tso_background_tennet: string;
        color_tso_background_50hertz: string;
        color_tso_background_transnet: string;
      };
      pressed: {
        color_tso_background_amprion: string;
        color_tso_background_tennet: string;
        color_tso_background_50hertz: string;
        color_tso_background_transnet: string;
      };
    };
  }
  interface PaletteOptions {
    customTextColor: {
      color_font_ft_helping_text: string;
      color_font_ft_nrtrl_disabled: string;
      color_font_ft_second_text: string;
      color_font_ft_text: string;
      color_font_ft_white: string;
      color_neutral_font_ft_nrtrl_enabled: string;
      color_neutral_font_ft_nrtrl_hover: string;
      color_neutral_font_ft_nrtrl_pressed: string;
      color_neutral_font_ft_ntrl_accent: string;
      color_neutral_font_ft_ntrl_lt: string;
      color_primary_font_ft_prim_accent: string;
      color_primary_font_ft_prim_enabled: string;
      color_primary_font_ft_prim_hover: string;
      color_primary_font_ft_prim_lt: string;
      color_primary_font_ft_prim_pressed: string;
    };
    customError: {
      color_signal_error_error: string;
      color_signal_error_error_2: string;
      color_signal_error_error_bg_accent: string;
      color_signal_error_error_bg_accent_2: string;
      color_signal_error_error_bg_dark: string;
      color_signal_error_error_bg_dark_2: string;
      color_signal_error_error_bg_light: string;
      color_signal_error_error_bg_light_2: string;
    };
    customInformation: {
      color_signal_information_information: string;
      color_signal_information_information_bg_accent: string;
      color_signal_information_information_bg_dark: string;
      color_signal_information_information_bg_light: string;
      color_signal_success_success: string;
      color_signal_success_success_bg_accent: string;
      color_signal_success_success_bg_dark: string;
      color_signal_success_success_bg_light: string;
      color_signal_warning_warning: string;
      color_signal_warning_warning_bg_accent: string;
      color_signal_warning_warning_bg_dark: string;
      color_signal_warning_warning_bg_light: string;
    };
    stroke: {
      color_primary_stroke_str_prim_accent: string;
      color_primary_stroke_str_prim_enabled: string;
      color_primary_stroke_str_prim_hover: string;
      color_primary_stroke_str_prim_pressed: string;

      color_neutral_stroke_str_ntrl_accent: string;
      color_neutral_stroke_str_ntrl_disabled: string;
      color_neutral_stroke_str_ntrl_enabled: string;
      color_neutral_stroke_str_ntrl_hover: string;
      color_neutral_stroke_str_ntrl_pressed: string;
    };
    chart: Record<string, string>;
    table: {
      color_other_table_header: string;
    };
  }
}

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: false;
    sm: false;
    md: false;
    lg: false;
    xl: false;

    //custom breakpoints
    mobile: true;
    tablet: true;
    laptop: true;
    desktop: true;
    wide: true;
  }
}

export const tsoPqTheme = createTheme({
  breakpoints: {
    //values are represented in px
    values: {
      mobile: 0,
      tablet: 601,
      laptop: 1241,
      desktop: 1441,
      wide: 1921,
    },
  },
  palette: {
    customTextColor: {
      color_primary_font_ft_prim_accent: '#52812d',
      color_primary_font_ft_prim_enabled: '#52812d',
      color_primary_font_ft_prim_hover: '#426725',
      color_primary_font_ft_prim_lt: '#eaf5e1',
      color_primary_font_ft_prim_pressed: '#324d1a',
      color_neutral_font_ft_nrtrl_enabled: '#555C62',
      color_neutral_font_ft_nrtrl_hover: '#40454a',
      color_neutral_font_ft_nrtrl_pressed: '#222528',
      color_neutral_font_ft_ntrl_accent: '#888f95',
      color_neutral_font_ft_ntrl_lt: '#e1e3e5',
      color_font_ft_helping_text: '#555c62',
      color_font_ft_nrtrl_disabled: '#888f95',
      color_font_ft_second_text: '#40454a',
      color_font_ft_text: '#112233',
      color_font_ft_white: '#ffffff',
    },
    customError: {
      color_signal_error_error: '#cc1d1d',
      color_signal_error_error_2: '#cc1d1d',
      color_signal_error_error_bg_accent: '#e69292',
      color_signal_error_error_bg_accent_2: '#e69292',
      color_signal_error_error_bg_dark: '#a31717',
      color_signal_error_error_bg_dark_2: '#a31717',
      color_signal_error_error_bg_light: '#fae8e8',
      color_signal_error_error_bg_light_2: '#fae8e8',
    },
    customInformation: {
      color_signal_information_information: '#1d6ac6',
      color_signal_information_information_bg_accent: '#d2e1f4',
      color_signal_information_information_bg_dark: '#17559e',
      color_signal_information_information_bg_light: '#e8f0f9',
      color_signal_success_success: '#36823c',
      color_signal_success_success_bg_accent: '#c5dfc7',
      color_signal_success_success_bg_dark: '#2a6830',
      color_signal_success_success_bg_light: '#d7ead9',
      color_signal_warning_warning: '#e96420',
      color_signal_warning_warning_bg_accent: '#fbe0d2',
      color_signal_warning_warning_bg_dark: '#c16131',
      color_signal_warning_warning_bg_light: '#fdf0e9',
    },
    background: {
      primary: {
        color_primary_background_bg_prim: '#eaf5e1',
        color_primary_background_bg_prim_accent: '#a5bf90',
        color_primary_background_bg_prim_enabled: '#52812d',
        color_primary_background_bg_prim_enabled_lt: '#eaf5e1',
        color_primary_background_bg_prim_hover: '#426725',
        color_primary_background_bg_prim_hover_lt: '#a5bf90',
        color_primary_background_bg_prim_lt: '#f4f9ef',
        color_primary_background_bg_prim_pressed: '#324d1a',
        color_primary_background_bg_prim_pressed_lt: '#8faf75',
      },
      other: {
        color_other_background: '#f9f9f9',
        color_other_background_white: '#ffffff',
      },
      neutral: {
        color_neutral_background_bg_neutral_lt: '#f7f8f9',
        color_neutral_background_bg_ntrl: '#e1e3e5',
        color_neutral_background_bg_ntrl_accent: '#c3c7ca',
        color_neutral_background_bg_ntrl_dark: '#a6abb0',
        color_neutral_background_bg_ntrl_disabled: '#e1e3e5',
        color_neutral_background_bg_ntrl_enabled: '#555c62',
        color_neutral_background_bg_ntrl_enabled_lt: '#e1e3e5',
        color_neutral_background_bg_ntrl_hover: '#40454a',
        color_neutral_background_bg_ntrl_hover_lt: '#c3c7ca',
        color_neutral_background_bg_ntrl_pressed: '#222528',
        color_neutral_background_bg_ntrl_pressed_lt: '#a6abb0',
      },
      tso: {
        active: {
          color_tso_background_amprion: '#D3AFF1',
          color_tso_background_tennet: '#BCE0A1',
          color_tso_background_50hertz: '#FEDC89',
          color_tso_background_transnet: '#A6CDD4',
        },
        hover: {
          color_tso_background_amprion: '#C387F4',
          color_tso_background_tennet: '#99CB73',
          color_tso_background_50hertz: '#FFCB4C',
          color_tso_background_transnet: '#7BB9C5',
        },
        pressed: {
          color_tso_background_amprion: '#A85FE4',
          color_tso_background_tennet: '#7AC143',
          color_tso_background_50hertz: '#FDB913',
          color_tso_background_transnet: '#4E9BA9',
        },
      },
    },

    stroke: {
      color_primary_stroke_str_prim_accent: '#709851',
      color_primary_stroke_str_prim_enabled: '#52812d',
      color_primary_stroke_str_prim_hover: '#426725',
      color_primary_stroke_str_prim_pressed: '#324d1a',

      color_neutral_stroke_str_ntrl_accent: '#888f95',
      color_neutral_stroke_str_ntrl_disabled: '#a6abb0',
      color_neutral_stroke_str_ntrl_enabled: '#555c62',
      color_neutral_stroke_str_ntrl_hover: '#40454a',
      color_neutral_stroke_str_ntrl_pressed: '#222528',
    },
    chart: {
      color_other_chart_1: '#0057a4',
      color_other_chart_10: '#008496',
      color_other_chart_11: '#aa297b',
      color_other_chart_12: '#00168d',
      color_other_chart_13: '#5c9142',
      color_other_chart_14: '#8f0000',
      color_other_chart_15: '#af6730',
      color_other_chart_16: '#3a505a',
      color_other_chart_17: '#276a32',
      color_other_chart_18: '#5c210d',
      color_other_chart_19: '#444444',
      color_other_chart_2: '#1ca5e8',
      color_other_chart_3: '#fd8428',
      color_other_chart_4: '#fe0027',
      color_other_chart_5: '#00412a',
      color_other_chart_6: '#fdd835',
      color_other_chart_7: '#764083',
      color_other_chart_8: '#f3006e',
      color_other_chart_9: '#7700a7',
    },
    table: {
      color_other_table_header: '#b4e291',
    },
  },
  shape: {
    border_radius_tso_border_radius_2: '0.125rem',
    border_radius_tso_border_radius_4: '0.25rem',
  },
  customShadows: {
    elevation_1: '0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)',
    elevation_2: '0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
    elevation_3: '0px 10px 12px 0px rgba(40, 45, 55, 0.10)',
  },

  typography: {
    fontFamily: 'Ubuntu, Open Sans, sans-serif',
    ubuntu: 'Ubuntu, sans-serif',
    openSans: 'Open Sans, sans-serif',
    fontsize_body_body_small: '0.75rem',
    fontsize_body_body_medium: '0.875rem',
    fontsize_body_body_large: '1rem',
    fontsize_button_button_small: '0.875rem',
    fontsize_button_button_medium: '1.125rem',
    fontsize_button_button_large: '1.25rem',
    lineHeight_s: '1rem',
    lineHeight_m: '1.125rem',
    lineHeight_l: '1.25rem',
    lineHeight_xl: '1.5rem',
    line_height_21: '1.3125rem',
    fontsize_label_label_small: '0.75rem',
    fontsize_label_label_medium: '0.875rem',
    fontsize_label_label_large: '1rem',
    fontsize_support_support_text_large: '0.75rem',
    fontsize_support_support_text_medium: '0.875rem',
    fontsize_support_support_text_small: '1.125rem',
    fontsize_title_list_section_small: '1.125rem',
    fontsize_title_list_section_medium: '1.25rem',
    fontsize_title_list_section_large: '1.375rem',
    fontsize_title_section_smaller: '1.5rem',
    fontsize_title_section_small: '1.75rem',
    fontsize_title_section_medium: '2rem',
    fontsize_title_titel_large: '4rem',

    pxToRem: (px: number) => `${px / 16}rem`,
  },

  spacingValues: {
    atomSpacing: {
      spacing_atom_gap_com_gap_m: '0.375rem',
      spacing_atom_padding_atom_padding_m: '0.375rem',
    },
    componentSpacing: {
      spacing_component_gap_com_gap_xs: '0.75rem',
      spacing_component_gap_com_gap_s: '1.125rem',
      spacing_component_gap_com_gap_m: '1.5rem',
      spacing_component_gap_com_gap_l: '2rem',
      spacing_component_padding_com_padding_xs: '0.75rem',
      spacing_component_padding_com_padding_s: '1.125rem',
      spacing_component_padding_com_padding_m: '1.5rem',
      spacing_component_padding_com_padding_l: '2rem',
      // NEW
      spacing_component_gap_2: '0.125rem',
      spacing_component_gap_4: '0.25rem',
      spacing_component_gap_8: '0.5rem',
      spacing_component_gap_12: '0.75rem',
      spacing_component_gap_16: '1rem',
      spacing_component_gap_24: '1.5rem',
      spacing_component_padding_4: '0.25rem',
      spacing_component_padding_8: '0.5rem',
      spacing_component_padding_12: '0.75rem',
      spacing_component_padding_16: '1rem',
      spacing_component_padding_24: '1.5rem',
      spacing_component_padding_32: '2rem',
    },
    buttonSpacing: {
      spacing_button_large_button_lg_gap: '0.5rem',
      spacing_button_large_button_lg_padding_s: '0.625rem',
      spacing_button_large_iconbutton_lg_padding: '0.625rem',
      spacing_button_large_button_lg_padding_m: '1.125rem',
      spacing_button_large_button_lg_padding_l: '1.5rem',
      spacing_button_middle_button_md_gap: '0.375rem',
      spacing_button_middle_button_md_padding_s: '0.5rem',
      spacing_button_middle_iconbutton_md_padding: '0.5rem',
      spacing_button_middle_button_md_padding_m: '0.75rem',
      spacing_button_middle_button_md_padding_l: '1.125rem',
      spacing_button_middle_button_md_padding_xl: '1.5rem',
      spacing_button_small_button_sm_gap: '0.3125rem',
      spacing_button_small_button_sm_padding_s: '0.4375rem',
      spacing_button_small_iconbutton_sm_padding: '0.5rem',
      spacing_button_small_button_sm_padding_m: '0.625rem',
      spacing_button_small_button_sm_padding_l: '0.875rem',
    },

    inputFieldSpacing: {
      spacing_inputfield_padding_inputfield_padding_xs: '0.25rem',
      spacing_inputfield_padding_inputfield_padding_s: '0.375rem',
      spacing_inputfield_padding_inputfield_padding_m: '0.4375rem',
      spacing_inputfield_padding_inputfield_padding_l: '1rem',
    },
    pageSpacing: {
      spacing_page_gap_page_gap_xxs: '1.125rem',
      spacing_page_gap_page_gap_xs: '1.5rem',
      spacing_page_gap_page_gap_s: '2rem',
      spacing_page_gap_page_gap_m: '3rem',
      spacing_page_gap_page_gap_l: '3.5rem',
      spacing_page_gap_page_gap_xl: '4rem',
      spacing_page_margin_page_margin_xs: '1.5rem',
      spacing_page_margin_page_margin_s: '2rem',
      spacing_page_margin_page_margin_m: '3rem',
      spacing_page_margin_page_margin_l: '3.5rem',
      spacing_page_margin_page_margin_xl: '4rem',
      // NEW
      spacing_page_gap_4: '0.25rem',
      spacing_page_gap_8: '0.5rem',
      spacing_page_gap_16: '1rem',
      spacing_page_gap_24: '1.5rem',
      spacing_page_gap_32: '2rem',
      spacing_page_gap_48: '3rem',
      spacing_page_gap_56: '3.5rem',
      spacing_page_gap_64: '4rem',
      spacing_page_margin_4: '0.25rem',
      spacing_page_margin_8: '0.5rem',
      spacing_page_margin_16: '1rem',
      spacing_page_margin_24: '1.5rem',
      spacing_page_margin_32: '2rem',
      spacing_page_margin_48: '3rem',
      spacing_page_margin_56: '3.5rem',
      spacing_page_margin_64: '4rem',
    },
  },

  paperTableContainer: { maxHeight: '44vh' },
  hoveredOrSelectedCell: { backgroundColor: '#40454a' },
  oddNumberedRow: { backgroundColor: '#c9c9c9' },
});
